import React, { Component } from 'react'
import Footer from '../../../components/Footer'
import Mainmenu from '../../../components/Mainmenu'
import Navbar from '../../../components/Navbar'
import DashboardContent from './DashboardContent'
export default class Dashboard extends Component {
    render() {
        return (
            <>
                <Navbar />
                <Mainmenu />

                <DashboardContent />
                {/* {! isAdmin() && <EditorDashboard /> } */}
                <Footer /> 

            </>


        )
    }
}
